import React, { FC, MouseEventHandler } from 'react';
import SquareContents from '../game/SquareContents';
import Square from './Square';

interface RowProps {
    contents: SquareContents[];
    x: number;
    omd:Function;
    omu:Function;
    omo:Function;
    ote:Function;
}

const Row: FC<RowProps> = ({ contents, x, omd, omu, omo, ote, children }) => {
    let squareArray: any = [];

    for(var i=0; i<contents.length; i++)
    squareArray.push(
        <Square key={'square' + i} contents={contents[i]} x={x} y={i} omd={omd} omo={omo} omu={omu} ote={ote} />
        );

    return (
        <div className="Row">
         {squareArray}
        </div>
    );
};

export default Row;